import { initUploadDropzones } from './uploads-ui.js';
export function initArticleUI(root = document) {
    if (window.location.pathname === '/' && (/^#post-\d+/.test(window.location.hash) || new URLSearchParams(window.location.search).has('openComments'))) {
        window.location.replace('/diskuze' + window.location.search + window.location.hash);
        return;
    }
    initDiscussionPreview(root);
    initArticlePlayerSearch(root);
    initUploadDropzones(root);
    const select = root.querySelector('[data-article-cover-select]');
    const preview = root.querySelector('[data-article-cover-preview]');
    if (select && preview && !select.dataset.previewBound) {
        select.dataset.previewBound = '1';
        const update = () => {
            const item = document.querySelector(`[data-media-id="${CSS.escape(select.value)}"]`);
            preview.replaceChildren();
            if (!item) return;
            const image = document.createElement('img');
            image.src = item.dataset.mediaPath;
            image.className = 'aspect-video w-full rounded-md object-cover';
            image.alt = item.dataset.mediaAlt || '';
            const x = root.querySelector('[name="cover_position_x"]')?.value || '50';
            const y = root.querySelector('[name="cover_position_y"]')?.value || '50';
            image.style.objectPosition = `${x}% ${y}%`;
            preview.append(image);
        };
        select.addEventListener('change', update);
        ['cover_position_x', 'cover_position_y'].forEach(name => root.querySelector(`[name="${name}"]`)?.addEventListener('input', update));
        update();
    }
    if (!window.__clasicoInlineDiscussionBound && window.naja) {
        window.__clasicoInlineDiscussionBound = true;
        window.naja.snippetHandler.addEventListener('afterUpdate', () => initArticleUI(document));

    }
}

let articleEditorRange = null;
document.addEventListener('selectionchange', () => {
    const selection = window.getSelection();
    const editor = document.querySelector('[data-mail-editor-surface]');
    if (editor && selection?.rangeCount && editor.contains(selection.anchorNode)) articleEditorRange = selection.getRangeAt(0).cloneRange();
});
document.addEventListener('click', event => {
    if (!event.target.closest('[data-article-insert-image]')) return;
    const picker = document.querySelector('[data-article-inline-image]');
    const editor = document.querySelector('[data-mail-editor-surface]');
    if (!picker?.value || !editor) return;
    editor.focus();
    if (articleEditorRange && editor.contains(articleEditorRange.startContainer)) {
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(articleEditorRange);
    }
    document.execCommand('insertImage', false, picker.value);
    editor.dispatchEvent(new Event('input', { bubbles: true }));
});

export function initDiscussionPreview(root) {
    root.querySelectorAll('[data-inline-discussion-form]').forEach(form => {
        if (form.dataset.previewBound) return;
        form.dataset.previewBound = '1';
        const text = form.querySelector('textarea');
        const checkbox = form.querySelector('[name="attach_preview"]');
        const preview = form.querySelector('[data-discussion-link-preview]');
        let timer, revision = 0;
        const update = () => {
            clearTimeout(timer);
            const current = ++revision;
            preview.replaceChildren();
            preview.classList.add('hidden');
            if (!checkbox?.checked || !/https?:\/\//i.test(text.value) || !window.naja) return;
            timer = setTimeout(async () => {
                try {
                    const response = await window.naja.makeRequest('POST', form.dataset.previewUrl, { text: text.value }, { history: false });
                    if (current !== revision || !response.discussionPreview) return;
                    const link = document.createElement('a');
                    link.href = response.discussionPreview.url;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    link.textContent = `${response.discussionPreview.label} · ${response.discussionPreview.url}`;
                    preview.append(link);
                    preview.classList.remove('hidden');
                } catch (_) { /* Náhled neblokuje odeslání. */ }
            }, 400);
        };
        text.addEventListener('input', update);
        checkbox.addEventListener('change', update);
    });
}

function initArticlePlayerSearch(root) {
    root.querySelectorAll('[data-article-player-search]').forEach(input => {
        if (input.dataset.searchBound) return;
        input.dataset.searchBound = '1';
        const select = input.parentElement.querySelector('[data-article-players]');
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        input.addEventListener('input', () => {
            const query = normalize(input.value.trim());
            Array.from(select.options).forEach(option => { option.hidden = !option.selected && !normalize(option.textContent).includes(query); });
        });
    });
}

